import { SuggestionType } from '@conversed/shared/src/central/types/suggestion-box.type';
import { z } from 'zod';

export const SuggestionBoxSendSchema = z.object({
  userName: z.string(),
  companyName: z.string(),
  suggestionType: z.enum(
    Object.values(SuggestionType) as [SuggestionType, ...SuggestionType[]],
  ),
  description: z.string(),
  frustration: z.string().optional(),
});

export type TSuggestionBoxSend = z.infer<typeof SuggestionBoxSendSchema>;
